var _g, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 196 196"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#play_svg__a)",
  opacity: 0.56
}, /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 84,
  r: 60,
  fill: "#F6F3FF"
}))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 97.999,
  cy: 83.999,
  r: 50,
  fill: "url(#play_svg__b)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m121 84.5-33.75 19.486V65.014z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "play_svg__b",
  x1: 29.785,
  x2: 155.106,
  y1: 23.285,
  y2: 32.018,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.027,
  stopColor: "#590EBC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.396,
  stopColor: "#8C35FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.966,
  stopColor: "#BE57DD"
})), /*#__PURE__*/React.createElement("filter", {
  id: "play_svg__a",
  width: 196,
  height: 196,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 12,
  result: "effect1_dropShadow_610_23269"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 14
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.745098 0 0 0 0 0.341176 0 0 0 0 0.866667 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_610_23269"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_610_23269",
  result: "shape"
})))));
export default SvgPlay;